var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ui.isLoading)?_c('div',{staticClass:"is-loading Section Content"}):_c('div',[_c('nav',{attrs:{"id":"sub"}},[_c('div',{class:['subnav-txt col-4-3']},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.event.name)+"\n      ")]),_vm._v(" "),_c('p',[_vm._v("Create and manage your Events")])])]),_vm._v(" "),(_vm.event.id)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }